import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var processedProfileSuggestions = function processedProfileSuggestions(suggestions) {
  var bio = suggestions.bio,
    location = suggestions.location,
    education = suggestions.education,
    pastRoles = suggestions.pastRoles,
    functionalAreas = suggestions.functionalAreas,
    industries = suggestions.industries,
    productTechnologies = suggestions.productTechnologies,
    stagesOfDevelopments = suggestions.stagesOfDevelopments,
    therapeuticAreas = suggestions.therapeuticAreas;
  var data = {
    bio: bio.accepted && bio.bio ? bio.bio : '',
    location: location.accepted && location.location ? location.location : '',
    education: education.filter(function (e) {
      return e.accepted;
    }).map(function (e) {
      return {
        consultant_profile_id: e.education.consultantProfileId,
        degree_id: e.education.degree ? e.education.degree.value : null,
        area_of_study: e.education.areaOfStudy,
        school: e.education.school,
        start_year: e.education.startDate ? new Date(e.education.startDate) : null,
        end_year: e.education.endDate ? new Date(e.education.endDate) : null
      };
    }),
    past_roles: pastRoles.filter(function (pr) {
      return pr.accepted;
    }).map(function (pr) {
      return {
        company_name: pr.pastRole.companyName,
        consultant_profile_id: pr.pastRole.consultantProfileId,
        current: pr.pastRole.current,
        description: pr.pastRole.description,
        end_date: pr.pastRole.endDate,
        start_date: pr.pastRole.startDate,
        title: pr.pastRole.title,
        company_id: pr.pastRole.companyId
      };
    })
  };
  var tags = [{
    id: 'functionalAreas',
    name: 'functional_areas',
    data: functionalAreas
  }, {
    id: 'industries',
    name: 'industries',
    data: industries
  }, {
    id: 'productTechnologies',
    name: 'product_technologies',
    data: productTechnologies
  }, {
    id: 'therapeuticAreas',
    name: 'therapeutic_areas',
    data: therapeuticAreas
  }, {
    id: 'stagesOfDevelopments',
    name: 'stages_of_development',
    data: stagesOfDevelopments
  }];
  var _loop = function _loop() {
    var tag = tags[i];
    data[tag.name] = tag.data.filter(function (t) {
      return t.accepted;
    }).map(function (t) {
      return _objectSpread({}, t[tag.id.slice(0, tag.id.length - 1)]);
    });
  };
  for (var i = 0; i < tags.length; i += 1) {
    _loop();
  }
  return Object.fromEntries(Object.entries(data).filter(function (entry) {
    return entry[1].length;
  }));
};
export default processedProfileSuggestions;